import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import withHooks from 'cityads-v3/decorators/withHooks'
import { useThemeChanger } from 'cityads-v3/hooks/theme'

import IconButton from '@material-ui/core/IconButton';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography'
import IconClose from '@material-ui/icons/CloseOutlined'

import DialogWrapper from './DialogWrapper';

import classNames from './Dialog.scss';

@withHooks(props => ({
  ...props,
  themeChanger: useThemeChanger()
}))
export default class Dialog extends Component {
  static propTypes = {
    open          : PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func,
    tab           : PropTypes.string,
    onTabChange   : PropTypes.func,
    tabs          : PropTypes.array,
    showLogo      : PropTypes.bool,
    title         : PropTypes.node,
    fullScreen    : PropTypes.bool,
  };

  static defaultProps = {
    showLogo: true,
  };

  state = {
    cta: this.getCta(),
  }

  getCta() {
    let cta = '';
    if( this.props.tabs && this.props.tabs.length ){
      let tab = this.props.tabs.filter(item => item.value === this.props.tab)[0];
      if( tab ) {
        cta = tab.cta || '';
      }
    }
    return cta;
  }

  handleTabChange(tab) {
    const cta = this.props.tabs.filter(item => item.value === tab)[0].cta;
    this.setState({
      cta
    });
    this.props.onTabChange(tab);
  }

  render() {
    const {
      open,
      onRequestClose,
      onClose,
      closeLink,
      title,
      showLogo,
      tabs,
      tab,
      onTabChange,
      scroll = 'body',
      children,
      childrenClassName,
      themeChanger,
      ...rest
    } = this.props;
    const curTab = (tabs && tabs.length > 1 && tabs.filter(item => item.value === tab)[0]) || false;

    return (
      <DialogWrapper
        open       = {open}
        onClose    = {onRequestClose || onClose}
        scroll     = {scroll}
        {...rest}
      >
        <IconButton
          onClick   = {closeLink ? undefined : onRequestClose}
          component = {closeLink ? forwardRef((props, ref) => <Link to={closeLink} {...props} ref={ref} />) : undefined}
          classes   = {{
            root: classNames.closeButton
          }}
        >
          <IconClose/>
        </IconButton>

        <div className={classNames.header}>
          {showLogo && (
            <div className={classNames.logo}>
              <img className={classNames.logoImg} alt="CityAds" src={
                themeChanger.theme.palette.type === 'dark'
                  ? require('cityads-v3/static/images/logoDark.svg')
                  : require('cityads-v3/static/images/logo.svg')
              } />
            </div>
          )}

          {title && (
            <Typography className={classNames.title}>
              {title}
            </Typography>
          )}

          {this.state.cta && (
            <div className={classNames.cta}>
              {this.state.cta}
            </div>
          )}
        </div>

        {/* TODO: придумать для этого вариант получше к тому времени, когда решат https://github.com/callemall/material-ui/issues/4155 */}
        { tabs && tabs.length > 1 && (
          <Tabs
            value          = {tab}
            onChange       = {(evt, newTab) => this.handleTabChange(newTab)}
            variant        = "fullWidth"
            indicatorColor = "primary"
            textColor      = "primary"
            classes        = {{
              root: classNames.tabs
            }}
          >
            {tabs.map(curTab => (
              <Tab
                key   = {curTab.value}
                value = {curTab.value}
                label = {curTab.label}
                classes = {{
                  root: classNames.tab
                }}
              />
            ))}
          </Tabs>
        )}

        {curTab ? curTab.children : undefined}

        {tabs && tabs.length === 1 && (
          tabs[0].children
        )}

        {(!tabs || !tabs.length) && children && (
          <div className={childrenClassName || classNames.children}>{children}</div>
        )}
      </DialogWrapper>
    );
  }
}
